import React, { useEffect } from "react";
import "./Photos.css";

import AOS from "aos";
import "aos/dist/aos.css";

/* IMPORT 24 IMAGES */

import img1 from "../../Asset/Images/ivideo3.png";
import img2 from "../../Asset/Images/ivideo5.png";
import img3 from "../../Asset/Images/p3.jpeg";
import img4 from "../../Asset/Images/p2.jpeg";
import img5 from "../../Asset/Images/treatment2.jpeg";
import img6 from "../../Asset/Images/p4.jpeg";
import img7 from "../../Asset/Images/p5.jpeg";
import img8 from "../../Asset/Images/ivideo4.png";
import img9 from "../../Asset/Images/p6.jpg";
import img10 from "../../Asset/Images/p7.jpg";
import img11 from "../../Asset/Images/p8.jpg";
import img12 from "../../Asset/Images/p9.jpg";
import img13 from "../../Asset/Images/iv1.jpeg";
import img14 from "../../Asset/Images/f5.jpeg";
import img15 from "../../Asset/Images/p10.jpg";
import img16 from "../../Asset/Images/p11.jpg";
import img17 from "../../Asset/Images/p12.jpg";
import img18 from "../../Asset/Images/p13.jpg";
import img19 from "../../Asset/Images/p14.jpeg";
import img20 from "../../Asset/Images/p15.jpeg";
import img21 from "../../Asset/Images/p16.jpeg";
import img22 from "../../Asset/Images/p17.png";
import img23 from "../../Asset/Images/p1.jpeg";
import img24 from "../../Asset/Images/p18.png";

/* ARRAY OF 24 IMAGES */

const images = [
  img1,img2,img3,img4,
  img5,img6,img7,img8,
  img9,img10,img11,img12,
  img13,img14,img15,img16,
  img17,img18,img19,img20,
  img21,img22,img23,img24
];

const Photos = () => {

  useEffect(() => {
    AOS.init({
      duration:1000,
      once:true
    });
  },[]);

  return (

    <div className="photos_page">

      <h1 className="gallery_title">
        Our <span>Gallery</span>
      </h1>

      <p className="gallery_subtitle">
        Moments of care, compassion and community at Maanavta Hitaay Seva Chatra.
      </p>

      <div className="gallery_grid">

        {images.map((img,index)=>(
          
          <div
            className="gallery_card"
            key={index}
            data-aos="zoom-in"
            data-aos-delay={index * 40}
          >

            <img src={img} alt={`gallery-${index}`} />

            <div className="gallery_overlay">
              <div className="overlay_frame">
                <p>Location : XYZ</p>
              </div>
            </div>

          </div>

        ))}

      </div>

    </div>
  );
};

export default Photos;